import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getFeaturedAnnouncements } from '../services/api';
import AnnouncementCard from './announcements/AnnouncementCard';
import './HomeAnnouncements.css';

/** Homepage section between HowItWorks and SuccessStories. Unlike those two
 * sections, content here is present and visible without scrolling — no
 * whileInView opacity gate (see the P14 spec's explicit note not to repeat
 * that pattern here). */
export default function HomeAnnouncements() {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    getFeaturedAnnouncements(3)
      .then((data) => setAnnouncements(Array.isArray(data) ? data : []))
      .catch(() => setAnnouncements([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  // Zero live announcements is a normal, expected state — render nothing at
  // all rather than an empty section or a "coming soon" placeholder.
  if (!loading && announcements.length === 0) return null;
  if (loading) return null;

  return (
    <section className="home-ann-section" aria-labelledby="home-ann-heading">
      <div className="home-ann-inner">
        <div className="home-ann-header">
          <div>
            <h2 id="home-ann-heading" className="home-ann-heading">Latest Announcements</h2>
            <p className="home-ann-subheading">Intakes, scholarships and deadlines that are open right now.</p>
          </div>
          <Link to="/announcements" className="home-ann-view-all">
            View all announcements <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>

        <div className="home-ann-grid">
          {announcements.map((a) => (
            <AnnouncementCard key={a.id} announcement={a} />
          ))}
        </div>
      </div>
    </section>
  );
}
